import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/it/messages';
import { messages as retailMessages } from '../translations/autohero-common/it/messages';

activateI18n('it', {
  ...retailMessages,
  ...sellOnlyMessages,
});
